import React, { Component } from 'react';
import {Head, Link, withRouteData} from 'react-static';
import styled from "styled-components";

import Header from '../components/Header';
import Footer from '../components/Footer';
import SocialLinks from "../components/SocialLinks";

const TermsStyle = styled.div`
	h4 {
		margin-top: 1.5rem;
	}
	
	p > p {
		margin-bottom: 0;
	}
	
	.container {
		margin-bottom: 2rem;
	}
`;

class Terms extends Component {
	render() {
		return (
			<TermsStyle>
				<Head>
					<title>Payment Policy | CTR Group</title>
					<meta name="description" content="Please follow the link to read our Payment Policy. If you have any questions, please contact our support team." />
				</Head>
				<Header />
				<div>
					<div className="container">
						<div className="row">
							<div className="columns medium-12">
								<h1 className="green text-center small-centered">Payment Policy</h1>

								<h4 className="green">ACCOUNTS</h4>
								<p className="caption">
									To meet the needs of Users and enforce the rules, Sonera Corporative Ltd will create an account of
									the User and will serve it to send and receive payments for the Product (radio transmission system
									with capacity transfer) for its production and sale, send and receive returns, send payments from
									name Sonera Corporative Ltd and ensure the receipt of funds by the User.
									<br/>Fulfilling the requirements of this Policy, which is part of the <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/terms-of-service`}>Terms of Service</Link> of the site
									https://ctr.group, the User grants Sonera Corporative Ltd the right and instructs her to act as its
									agent in respect of account management and performing certain operations with them in accordance
									with the provisions established in this document.
									You accept and agree that:
									<br/>- Sonera Corporative Ltd is not a banking organization or financial company licensed to conduct
									banking operations and it does not offer banking or other financial services;
									<br/>- The funds on your account are considered unsecured obligations;
									<br/>- You grant Sonera Corporative Ltd the right to make payments using the accounts on the
									Website related to the sale and purchase, as well as depositing and withdrawing funds from the
									account;
									<br/>- You will be considered as an unsecured creditor of Sonera Corporative Ltd;
									<br/>- Sonera Corporative Ltd will not act as an authorized representative or proxy for these funds or
									payments;
									<br/>- The amount of funds in your account is not a security or security deposit;
									<br/>- Funds can only be deposited into your account by an authorized person, for example, an official
									representative of Sonera Corporative Ltd, and you must use only the mechanisms offered on the
									Website to deposit and withdraw funds;
									<br/>- Sonera Corporative Ltd will keep funds from your account on its bank account with a financial
									institution or otherwise, at its discretion, and these funds will not be deposited in your personal
									account;
									<br/>- Sonera Corporative Ltd has the right to combine these funds with the funds of other users and
									own means. These combined funds can be used for our common corporate purposes or for
									other commercial activities.
								</p>

								<h4 className="green">PAYMENTS</h4>
								<p className="caption">
									The user must contribute to the deposit using the mechanisms offered on the Website.
									<br/>The user sends payments ONLY to his / her own SONERA account, using his / her own credit
									cards, bank accounts, ETHEREUM or BITCOIN. IF USERS DO NOT OBSERVE THIS RULE,
									THEIR ACCOUNTS MAY BE SUSPENDED TEMPORARILY OR COMPLETELY CLOSED.
									<br/>The user has the right to deposit funds into the account via bank transfer, credit card or payment
									system.
									<br/>The maximum size of the deposit by credit card is 500 euros. The maximum size of the deposit
									made by bank transfer or through the Ethereum or Bitcoin payment system is unlimited.
									<br/>All payments made with the help of credit cards or Ethereum and Bitcoin payment systems are
									credited to the account instantly. The transfer of funds made via bank transfer is made after receipt
									and verification. The commission for making credit cards is 5%. Sonera Corporative Ltd is not
									responsible for any additional fees charged by payment systems.
									<br/>We charge a service fee for errors in making payments, such as: a mistake in the payment
									application or a lack of a payment application; incorrect amount, the payer is not the owner of the
									account. The minimum fee is 5 euros. The service fee will be withheld from incoming funds.
								</p>

								<h4 className="green">SPENDING AND PLACEMENT OF FUNDS</h4>
								<p className="caption">
									When the User decides to purchase the Token through the mechanisms offered on the Website, he
									or she grants Sonera Corporative Ltd the unrestricted right to use (transfer) the appropriate amount.
									<br/>Sonera Corporative Ltd reserves the right, at its sole discretion and in accordance with the
									requirements of the law, to take reasonable measures in the event that the User has committed,
									allegedly committed or attempts to commit any fraudulent or illegal transactions, or has violated the
									Sonera Corporation Corporation User Agreement including this Policy.
									<br/>Placement of funds on the account of the User is carried out on the basis of settlements and within
									the terms provided by the terms of the User Agreement.
								</p>

								<h4 className="green">WITHDRAWAL OF FUNDS</h4>
								<p className="caption">
									To withdraw funds, the User must use the mechanisms offered by Sonera Corporative Ltd on the
									Website, in particular, money transfer, Ethereum or Bitcoin payment systems and Visa / Mastercard
									cards in euros issued to residents in Europe.
									<br/>PAYMENTS ARE ALLOWED ONLY FOR A USER USING THE OWN BANK
									ACCOUNT,ETHEREUM OR BITCOIN PURSE, CREDIT CARD. IF USERS DO NOT OBSERVE
									THIS RULE, THEIR ACCOUNTS MAY BE TEMPORARILY SUSPENDED OR COMPLETELY
									CLOSED
									<br/>The maximum amount of payment by bank transfers is not limited. The amount of payment through
									Ethereum or Bitcoin is limited to 2500 (Two thousand five hundred) euros per one conclusion. Users
									can request only one output per day, regardless of the method. Payment systems may impose
									certain restrictions, which can only be negotiated between the user and the relevant payment
									companies. Sonera Corporative Ltd is not responsible for any additional fees entered by payment
									systems. Sonera Corporative Ltd may impose additional fees in the event of return or refusal of
									payment due to inaccurate bank details provided by the user or for any other reason that will result in
									the bank refunding the payment.
								</p>

								<h4 className="green">REFUNDS</h4>
								<p className="caption">
									Refunds are made in accordance with the <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/refund-policy`}>Refund Policy</Link>.
								</p>

								<h4 className="green">POSSIBLE INVOICES AND TAXES</h4>
								<p className="caption">
									Sonera Corporative Ltd is not responsible for informing, issuing any invoices, as well as indicating,
									transferring or collecting any taxes related to User funds. The user is fully responsible for the
									awareness of whether billing is required when receiving or sending funds in accordance with
									applicable law. In addition, the User is fully responsible for knowledge of the following: (a) which
									Party, User or Sonera Corporative Ltd is required by law to transfer value-added tax, income tax or
									any other taxes and fees to the relevant government authorities, if this applicable; (b) should Sonera
									Corporative Ltd withhold funds from the User's funds in accordance with applicable law and, if so,
									whether Sonera Corporative Ltd should be notified of this, as well as the fact of meeting the
									obligation (Sonera Corporation, at its sole discretion, refund this amount from other funds, or the
									User will refund such amount to Sonera Corporative Ltd) for the payment of any withheld amount to
									the relevant state authorities, including fees and penalties. If necessary, in the event that state
									authorities carry out any investigation into Sonera Corporative Ltd, the User is obliged to promptly
									cooperate with Sonera Corporative Ltd, providing her with all necessary documents requested for
									the purposes of such investigation.
								</p>

								<h4 className="green">PAYMENT METHODS</h4>
								<p className="caption">
									To use certain Services provided on the Website, the User must provide information on at least one
									payment method.
									<br/>By providing information on the payment method on the Website, the User represents, warrants and
									accepts that: (a) The User has the legal authority to provide such information to Sonera Corporative
									Ltd or other payment system, financial institution, bank and other organizations selected by Sonera
									Corporative Ltd for the implementation of transactions; (b) The User has the legal authority to make
									payments using the payment method chosen by the User; (c) these actions do not violate the terms
									of use by the User of such payment method and the norm of the current legislation. By giving its
									consent to make payment by means of some form of payment on the Website, the User declares,
									warrants and accepts that his or her account has sufficient funds to make payment by the chosen
									method of payment. In the event of a lack of funds to make a payment on the user's account in the
									payment system, the User is fully responsible for depositing funds into his or her account in a
									different way. Sonera Corporative Ltd reserves the right to demand compensation from the User and
									the User is obliged to reimburse the appropriate amount to Sonera Corporative Ltd if Sonera
									Corporative Ltd identifies erroneous or duplicate transactions or for any reason receives a request
									for reimbursement from the payment system, selected by the User. The User agrees that Sonera
									Corporative Ltd reserves the right to receive such compensation by debiting funds from future
									deposits or withdrawing funds from the User's account in the payment system chosen by the User or
									to require compensation from the User by any other legal means. Without prejudice to any other
									rights and remedies of Sonera Corporative Ltd, Sonera Corporative Ltd has the right to deactivate
									the User's account upon receipt of the User's refusal to refund the paid funds or other funds due to
									Sonera Corporative Ltd in accordance with this Policy or the User Agreement of the site
									https://ctr.group.
								</p>

								<h4 className="green">PAYMENT GUARANTEE</h4>
								<p className="caption">
									Sonera Corporative Ltd pays special attention to ensuring the safety of Users' funds that they have
									entrusted to Sonera Corporative Ltd, therefore Sonera Corporative Ltd takes certain security
									measures that comply with modern technological standards.
									<br/>The guarantee of payment does not apply to: (a) Users who violate the terms of the Agreement; (b)
									Users who do not exactly comply with the provisions of the User Agreement, documents that are an
									integral part thereof, and applications; (c) Users who are in some way connected with the violation,
									alleged or actual, or operate together with another User or Users violating the User Agreement, its
									integral parts and applications; or (d) persons engaged in fraudulent activities, whether presumed or
									actual, or using this guarantee for improper purposes.
								</p>

								<h4 className="green">OTHER REFERENCES</h4>
								<p className="caption">Also see our <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/terms-of-service`}>Terms of Service</Link> and our <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/refund-policy`}>Refund Policy</Link>.</p>

								<h4 className="green">CONTACT</h4>
								<p className="caption">For general inquiries, you can contact us by E-Mail at <a href="mailto:info@ctr.group">info@ctr.group</a></p>
								<p className="caption">If you have a technical or site related issue, contact us at <a href="mailto:support@ctr.group">support@ctr.group</a></p>
								<p className="caption">You can also join our <a href="https://t.me/ctrgroupico" target="_blank" rel="noopener noreferrer">Telegram Channel</a></p>
							</div>
						</div>
					</div>
				</div>
				<SocialLinks />
				<Footer />
			</TermsStyle>
		)
	}
}

export default withRouteData(Terms)


// WEBPACK FOOTER //
// /opt/build/repo/src/containers/PaymentPolicy.js